import { create } from "zustand";
import { DestinationIDData } from "@/lib/Types/DestinationIDData";

export interface LocationNames {
  countryName: string | null;
  regionName: string | null;
  cityName: string | null;
}

interface LocationState {
  location: LocationNames;
  setLocationNames: (destinationIDData: DestinationIDData[] | null) => void;
}

// Helper function to extract location names from DestinationID data
const extractLocationNames = (
  destinationIDData: DestinationIDData[] | null
): LocationNames => {
  if (!destinationIDData) {
    return {
      countryName: null,
      regionName: null,
      cityName: null,
    };
  }

  const location: LocationNames = {
    countryName: null,
    regionName: null,
    cityName: null,
  };

  destinationIDData.forEach((destinationID) => {
    switch (destinationID.level) {
      case "COUNTRY":
        location.countryName = destinationID.name;
        break;
      case "REGION":
        location.regionName = destinationID.name;
        break;
      case "CITY":
        location.cityName = destinationID.name;
        break;
    }
  });

  return location;
};

export const useLocationStore = create<LocationState>((set, get) => ({
  location: {
    countryName: null,
    regionName: null,
    cityName: null,
  },
  setLocationNames: (destinationIDData: DestinationIDData[] | null) => {
    const newLocation = extractLocationNames(destinationIDData);
    const current = get().location;
    if (
      current.countryName === newLocation.countryName &&
      current.regionName === newLocation.regionName &&
      current.cityName === newLocation.cityName
    ) {
      return;
    }
    set({ location: newLocation });
  },
}));
